import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EnabledRequirementType } from "features/requirements/enums/enabledRequirementType";
import React from "react";
import { useHistory } from "react-router-dom";
import ContactDTO from "../dtos/ContactDTO";
import { ContactType } from "../enums/contactType";
import ContactIcon from "./ContactIcon";
import RolesChecker from "./RolesChecker";
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from "features/shared/helpers/modules";
import { getContactChangeRoute } from "features/shared/helpers/routeHelper";
import { isEnabledCustomForm } from "features/requirements/helpers/requirementTypeHelper";

const portalConfig = loadPortalConfig();
const typesForEditing: ContactType[] = ["Email", "Mobile", "Phone"];

interface Props {
  contact: ContactDTO;
  enableEdit?: boolean;
}

const Contact = ({ contact, enableEdit = false }: Props) => {
  // history
  const history = useHistory();

  // helpers
  const isEnabledContactChange = (contactType: ContactType) => { 
    if (contactType === "Email" && isEnabledCustomForm("ZMENA_EMAILU")) {
      return true;
    } else if (contactType === "Mobile" && isEnabledCustomForm("ZMENA_MOBIL_TELEFONU")) {
      return true;
    } else if (contactType === "Phone" && isEnabledCustomForm("ZMENATELEFONU")) {
      return true;
    }

    return false;
  }

  // handlers
  const editContactHandler = (contactType: ContactType) => {
    history.push({
      pathname: getContactChangeRoute(contactType),
      state: contact
    });
  }

  // sub-renders
  const renderEditButton = () => {
    if (enableEdit && contact.contactType && typesForEditing.includes(contact.contactType)) {
      return (
        <RenderWrapper isVisible={() => isEnabledContactChange(contact.contactType!)}>
          <RolesChecker enabledRoles="Contributor">
            <div className="col-auto pl-3">
              <span className="text-secondary" role="button" onClick={() => editContactHandler(contact.contactType!)}>
                <FontAwesomeIcon icon="edit"/>
              </span>
            </div>
          </RolesChecker>
        </RenderWrapper>
      );
    }    
  }

  // render
  return (
    <div className="py-1">
      <div className="row no-gutters align-items-center">
        <div className="col">
          <div className="d-flex align-items-center">
            <ContactIcon contactType={contact.contactType!} />
            <div className="pl-3 text-truncate" title={contact.value}>
              {contact.value}
            </div>
          </div>
        </div>
        {renderEditButton()}
      </div>
    </div>
  );
};

export default Contact;
